const ResultExportIndex = () => import("@/pages/lab/resultExport/ResultExportIndex");
const ResultExportSingle = () => import("@/pages/lab/resultExport/ResultExportSingle");
const ResultExportDetail = () => import("@/pages/lab/resultExport/ResultExportDetail");

export class ResultExportRoutes {
    constructor() {
        this.route_root = "result-exports";
        this.type_singular = "Result Export";
        this.type_plural = "Result Exports";

        this.routes = [
            {
                path: this.route_root,
                component: {
                    render(c) {
                        return c("router-view");
                    }
                },
                redirect: this.route_root,
                name: this.type_plural,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: "",
                        component: ResultExportIndex,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ":result_export_id",
                        name: this.type_singular,
                        component: ResultExportSingle,
                        children: [
                            {
                                path: "",
                                component: ResultExportDetail,
                                meta: { requiresAuth: true }
                            }
                        ]
                    }
                ]
            }
        ];

        this.public_routes = [];
    }

    static fetchRoutes() {
        let this_obj = new this();
        return this_obj.routes;
    }

    static fetchPublicRoutes() {
        let this_obj = new this();
        return this_obj.public_routes;
    }
}